(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/init-result.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/init-result.js');

(function(Backbone, _, svs) {
  'use strict';


  svs.grassroots.common.init({ pushState: false });
  svs.grassroots.app.start();
})(Backbone, _, svs);


 })(window);